<template>
  <div
    class="footer-marquee w-100 d-flex"
    :style="{ backgroundColor: background }"
  >
    <div class="marquee-text" :style="{ color: background }">
      ZERONE ZERONE ZERONE ZERONE ZERONE ZERONE
    </div>
    <div class="marquee-text" :style="{ color: background }">
      ZERONE ZERONE ZERONE ZERONE ZERONE ZERONE
    </div>
  </div>

  <div class="footer-content blue-gradient text-light py-4">
    <div
      class="container-xl d-flex flex-column flex-md-row flex-wrap flex-md-nowrap h-100"
    >
      <div
        class="h-100 d-flex flex-column justify-content-around px-5 copyright"
      >
        <div>
          <img
            src="@/assets/image/zerone logo(footer).png"
            alt="logo"
            class="logo"
          />
          <ul class="list-unstyled">
            <li class="mb-1">零壹科技股份有限公司</li>
            <li class="mb-1">地址：台北市內湖路一段360巷8號10樓</li>
            <li class="mb-1">(02)2656-5656</li>
            <li>(02)2656-5810</li>
          </ul>
        </div>
        <ul
          class="d-flex d-md-none justify-content-around align-items-center list-unstyled fs-4 social-icon"
        >
          <li>
            <a
              href="https://www.facebook.com/zeronetech"
              class="d-block rounded-circle bg-light d-flex justify-content-center align-items-center me-4"
              ><i class="bi bi-facebook"></i
            ></a>
          </li>
          <li>
            <a
              href="https://page.line.me/zeronetech"
              class="d-block rounded-circle bg-light d-flex justify-content-center align-items-center me-4"
              ><i class="bi bi-line"></i
            ></a>
          </li>
          <li>
            <a
              href="https://open.firstory.me/embed/user/zeronetech"
              class="d-block rounded-circle bg-light d-flex justify-content-center align-items-center me-4"
              ><font-awesome-icon :icon="['fas', 'podcast']"
            /></a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/c/%E9%9B%B6%E5%A3%B9%E7%A7%91%E6%8A%80"
              class="d-block rounded-circle bg-light d-flex justify-content-center align-items-center"
              ><i class="bi bi-youtube"></i
            ></a>
          </li>
        </ul>

        <ul
          class="w-100 d-flex d-md-none flex-column justify-content-evenly list-unstyled mb-0"
        >
          <li class="mb-4">
            <a
              href="/campaign/2024techinside#section-event-intro"
              class="link-white"
              >活動簡介</a
            >
          </li>
          <li class="mb-4">
            <a
              href="/campaign/2024techinside#section-event-feature"
              class="link-white"
              >活動特點</a
            >
          </li>
          <li class="mb-4">
            <a href="/campaign/2024techinside#section-issue" class="link-white"
              >六大應用</a
            >
          </li>
          <li class="mb-4">
            <a
              href="/campaign/2024techinside#section-keynote"
              class="link-white"
              >專家洞察</a
            >
          </li>
          <li class="mb-4">
            <a
              href="/campaign/2024techinside#section-organizer"
              class="link-white"
              >合作夥伴</a
            >
          </li>
        </ul>
        <p class="fw-light">© 零壹科技股份有限公司 2024, All Rights Reserved</p>
      </div>
      <div
        class="h-100 w-50 d-none d-md-flex flex-column justify-content-around"
      >
        <ul
          class="w-100 d-flex justify-content-evenly align-items-center list-unstyled"
        >
          <li>
            <a
              href="/campaign/2024techinside#section-event-intro"
              class="link-white"
              >活動簡介</a
            >
          </li>
          <li>
            <a
              href="/campaign/2024techinside#section-event-feature"
              class="link-white"
              >活動特點</a
            >
          </li>
          <li>
            <a href="/campaign/2024techinside#section-issue" class="link-white"
              >六大應用</a
            >
          </li>
          <li>
            <a
              href="/campaign/2024techinside#section-keynote"
              class="link-white"
              >專家洞察</a
            >
          </li>
          <li>
            <a
              href="/campaign/2024techinside#section-organizer"
              class="link-white"
              >合作夥伴</a
            >
          </li>
        </ul>
        <ul
          class="w-100 d-flex justify-content-center align-items-center list-unstyled fs-4 social-icon"
        >
          <li>
            <a
              href="https://www.facebook.com/zeronetech"
              class="d-block rounded-circle bg-light d-flex justify-content-center align-items-center me-5"
              ><i class="bi bi-facebook"></i
            ></a>
          </li>
          <li>
            <a
              href="https://page.line.me/zeronetech"
              class="d-block rounded-circle bg-light d-flex justify-content-center align-items-center me-5"
              ><i class="bi bi-line"></i
            ></a>
          </li>
          <li>
            <a
              href="https://open.firstory.me/embed/user/zeronetech"
              class="d-block rounded-circle bg-light d-flex justify-content-center align-items-center me-5"
              ><font-awesome-icon :icon="['fas', 'podcast']"
            /></a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/c/%E9%9B%B6%E5%A3%B9%E7%A7%91%E6%8A%80"
              class="d-block rounded-circle bg-light d-flex justify-content-center align-items-center"
              ><i class="bi bi-youtube"></i
            ></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { footerStore } from "@/stores/footerStore";

export default {
  computed: {
    background() {
      return footerStore().background;
    },
  },
};
</script>

<style lang="scss">
.footer-marquee {
  overflow: hidden;
  font-size: 220px;
  text-shadow: -1px -1px 0 #68b5d7, 1px -1px 0 #68b5d7, -1px 1px 0 #68b5d7,
    1px 1px 0 #68b5d7;
}

.marquee-text {
  display: inline-block;
  white-space: nowrap;
  animation: marquee 20s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.footer-content {
  height: 450px;

  @media (max-width: $md) {
    height: 655px;
  }

  .link-white {
    color: #fff;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: #27a1d8;
    }
  }

  .social-icon {
    width: 60%;
    a {
      width: 48px;
      height: 48px;
    }

    i,
    svg {
      color: #27a1d8;
    }
  }

  .logo {
    margin-bottom: 48px;

    @media (max-width: $md) {
      margin-bottom: 24px;
    }
  }

  .copyright,
  .footer-bar {
    width: 50%;

    @media (max-width: $md) {
      width: 100%;
    }
  }
}
</style>
